import { createElementIdSlice } from '../utils/action/createElementSlice';
export const InfoBarState = createElementIdSlice({
    elementName: 'info-bar',
    initialState: {},
    reducers: {
        notifyMenuButtonSelection: (state, _action) => state,
    },
});
